<template>
  <div class="container">
    <page-install />

    <page-examples />

    <page-props />

    <page-events />

    <page-methods />
  </div>
</template>

<script>
import PageMethods from './PageMethods.vue'
import PageEvents from './PageEvents.vue'
import PageProps from './PageProps.vue'
import PageInstall from './PageInstall.vue'
import PageExamples from './PageExamples.vue'

export default {
  components: {
    PageInstall,
    PageExamples,
    PageProps,
    PageEvents,
    PageMethods
  }
}
</script>
